import React from "react";

import { ModalContext } from "../../../libs/ModalProvider";
import { IClass, INotification } from "../../../state";
import { convertLink, dateTimeStr } from "../../../libs/Util";
import Confirm from "../../../molecules/Confirm";

import style from "./NotificationList.module.scss";

export interface INotificationListDispatchProps {
  toBuildNewNotification: () => void;
  toCopyNotification: (id: number) => void;
  toEditNotification: (id: number) => void;
  deleteNotification: (id: number) => void;
}

export interface INotificationListStateProps {
  title: string;
  calling: boolean;
  notifications: INotification[];
  classes: IClass[];
}

export interface INotificationListProps
  extends INotificationListDispatchProps,
    INotificationListStateProps {}

export const NotificationList = (props: INotificationListProps) => {
  const ctx = React.useContext(ModalContext);
  return (
    <div className={style.list}>
      <div className="d-flex align-items-center mb-5">
        <h3 className="me-4 mb-0">{props.title}</h3>
        <span>GEAR上でクラスにお知らせをすることができます。</span>
      </div>
      <div className={style.btnArea}>
        <button
          className="btn btn-outline-primary"
          onClick={e => {
            e.preventDefault();
            props.toBuildNewNotification();
          }}
        >
          新規お知らせ作成
        </button>
      </div>
      <table className={style.table}>
        <thead>
          <tr>
            <th>お知らせ名</th>
            <th className="text-center">送信先クラス</th>
            <th>作成日</th>
            <th>最終更新日</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {props.notifications.map(n => {
            return (
              <tr key={n.id}>
                <td
                  className={style.content}
                  dangerouslySetInnerHTML={{ __html: convertLink(n.content) }}
                />
                <td width={120} className="text-center">
                  {n.class_ids.length === props.classes.length
                    ? "全校"
                    : n.class_ids
                        .map(id => {
                          const c = props.classes.filter(cl => id === cl.id)[0];
                          return c ? c.full_name : "";
                        })
                        .join(",")}
                  {n.for_teacher
                    ? n.class_ids.length > 0
                      ? "および先生"
                      : "先生"
                    : ""}
                </td>
                <td className={style.time}>{dateTimeStr(n.created_at)}</td>
                <td className={style.time}>{dateTimeStr(n.updated_at)}</td>
                <td className={style.btnField}>
                  <button
                    onClick={() => props.toCopyNotification(n.id)}
                    className="btn btn-outline me-3"
                  >
                    複製
                  </button>
                  <button
                    onClick={() => props.toEditNotification(n.id)}
                    className="btn btn-outline me-3"
                  >
                    編集
                  </button>
                  <button
                    disabled={props.calling}
                    onClick={() => {
                      ctx.actions.showModal(
                        <Confirm
                          calling={props.calling}
                          content={`${
                            n.content.length > 50
                              ? n.content.substr(0, 50) + "..."
                              : n.content
                          }のお知らせを削除してもいいですか?`}
                          closeModal={() => {
                            ctx.actions.closeModal();
                          }}
                          callback={() => {
                            props.deleteNotification(n.id);
                          }}
                        />,
                      );
                    }}
                    className="btn btn-outline"
                  >
                    削除
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default NotificationList;
